import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useState} from 'react'
import {useGoogleLogin} from '@react-oauth/google'
import {FcGoogle} from "react-icons/fc";
import {renderIfElse} from "../../Shared";
import classNames from "classnames";
import {Spin} from "antd";

export default function GoogleLoginBtn({
                                           onSuccess,
                                           label = 'Sign in with Google',
                                           renderButton,
                                       }) {
    const t = useTranslate()
    const [loading, setLoading] = useState(false)

    const login = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            onSuccess({
                token: tokenResponse.access_token,
                provider: 'google',
            })
            setTimeout(() => setLoading(false), 500)
        },
        onError: (err) => {
            setLoading(false)
            console.log('Login failed:', err)
        },
        onNonOAuthError: () => {
            setLoading(false)
        },
        scope: 'openid profile email',
    })

    const handleClick = useCallback(() => {
        setLoading(true)
        login()
    }, [login])

    const btn = (
        <button
            onClick={handleClick}
            style={{
                minHeight: 44,
                fontSize: 15,
                fontWeight: '500',
                fontFamily: 'SF Pro Text, SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif',
                letterSpacing: '0.03em',
            }}
            className="w-full flex flex-center gap-3 background border border-color-100 rounded-lg hover:shadow hover:scale-2xs cursor-pointer">
            <FcGoogle size={17}/>
            <span
                className={classNames("tracking-wide leading-none", loading ? "text-color-300 italic" : "text-gray-700")}>
                {loading ? t('logging in...') : t(label)}
            </span>
            {loading && <Spin spinning/>}
        </button>
    )

    return renderIfElse(renderButton, renderButton, btn)
}